import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { showLoader, hideLoader } from "./loaderSlice";
const dynamicBaseQuery = async (args, api, extraOptions) => {
  //const state = api.getState();
  //const companyName = state?.auth?.companyName?.trim().replace(/\s+/g, '');
  const environment = process.env.REACT_APP_ENV;
  // Determine the baseUrl based on the stdevate.

  const baseUrl =
    environment === "production" || environment === "prod"
      ? `https://order2ur5moveservices.hiborder2u.com/`
      : `https://order2ur5moveservices.qa.hiborder2u.com/`;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      // const token = 'eyJhbGciOiJIUzI1NiJ9.eyJzZWxlY3RlZENsaWVudCI6IjA5MTggLSAxMDAwIHwgRHJhZWdlciIsIlVuaXF1ZUlEIjoiMTY3NzAyXzE3NzY0MjEzMjU1NTkiLCJzZXNzaW9uVG9tZW91dEluTWludXRlIjoiNjAiLCJyb2xlIjoiWzkyMDhdIiwiZGl2TnVtYmVyIjpudWxsLCJBcHBVc2VySWQiOjE2NzcwMiwiZW52IjoiREVWIiwiaXNzdWVyIjoiYXV0aCBzZXJldnIiLCJjdXJyZW50Q29tcERpdk51bWJlciI6IjEwMDAiLCJjb21wRGl2SWQiOm51bGwsImNvbXBOdW1iZXIiOm51bGwsImN1cnJlbnRDb21wYW55TmFtZSI6IkRyYWVnZXIiLCJBcHBJZCI6MjI2MiwiY3VycmVudENvbXBhbnlJRCI6MjIsImN1cnJlbnRDb21wRGl2SUQiOjkyMywiVXNlcklkIjoyODc2LCJoYXZlTXVsdGlwbGVDbGllbnQiOnRydWUsImN1cnJlbnRDb21wYW55TnVtYmVyIjoiMDkxOCIsImV4cCI6MTc3NjQyNzIxMzMwMX0.aYW7rowWhI_Ohf224rEEg4r1vGAQGpyp0XJ9bdKtOr4'

      if (token) {
        headers.set("jwtToken", `${token}`);        
        // if(environment === "dev") headers.set("requestdomain", `http://localhost:3000/orderaddress`);
        if (environment === "dev") headers.set("requestdomain", `https://dev.hibbertmcoe.com/orderaddress`);
      }
      return headers;
    },
  });

  // 3. Call the raw base query with the original arguments.
  return rawBaseQuery(args, api, extraOptions);
};
//const token = " ";

// Define our single API slice object
export const orderSlice = createApi({
  reducerPath: "orderApi",
  // 2. Use the custom dynamicBaseQuery function here.
  baseQuery: dynamicBaseQuery,
  tagTypes: ["orderManageement"],
  endpoints: (builder) => ({
    getSearchData: builder.query({
      query: () => "/searchOrderData",
      onCacheEntryAdded: async (arg, { dispatch, cacheEntryRemoved }) => {
        dispatch(showLoader());
        await cacheEntryRemoved;
        dispatch(hideLoader());
      },
      providesTags: ["orderManageement"],
    }),
    searchOrderData: builder.mutation({
      query: (searchOrderData) => ({
        url: "v1/searchOrderDetails",
        method: "POST",
        // headers: { customToken: process.env.REACT_APP_CUSTOM_TOKEN },
        body: searchOrderData,
      }),
      onQueryStarted: async (arg, { dispatch }) => {
        dispatch(showLoader());
        return () => dispatch(hideLoader());
      },
      invalidatesTags: ["orderManageement"],
    }),
    getOrderPagination: builder.query({
      query: (payload = {}) => ({
        url: "v1/getOrderListPagination",
        method: "POST",
        body: payload,
      }),
      onQueryStarted: async (arg, { dispatch }) => {
        dispatch(showLoader());
        return () => dispatch(hideLoader());
      },
      providesTags: ["orderManageement"],
    }),
    updateOrder: builder.mutation({
      query: (orderData) => ({
        url: "v1/updateOrderDetails",
        method: "POST",
        // headers: { customToken: process.env.REACT_APP_CUSTOM_TOKEN },
        body: orderData,
      }),
      onQueryStarted: async (arg, { dispatch }) => {
        dispatch(showLoader());
        return () => dispatch(hideLoader());
      },
      invalidatesTags: ["orderManageement"],
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const {
  useGetSearchDataQuery,
  useSearchOrderDataMutation,
  useGetOrderPaginationQuery,
  useUpdateOrderMutation,
} = orderSlice;
